import {
    LIST_INHIBITIONS,
    LIST_INHIBITIONS_SUCCESS,
    LIST_INHIBITIONS_ERROR,
    ADD_INHIBITIONS,
    SAVE_INHIBITIONS,
    SAVE_INHIBITIONS_SUCCESS,
    SAVE_INHIBITIONS_ERROR,
    EDIT_INHIBITIONS,
    UPDATE_INHIBITIONS,
    UPDATE_INHIBITIONS_SUCCESS,
    UPDATE_INHIBITIONS_ERROR,
    DELETE_INHIBITIONS,
    DELETE_INHIBITIONS_SUCCESS,
    DELETE_INHIBITIONS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    inhibitions: null,
    actualPage: null,
    isLast: null,
    isFirst: null,
    total: null,
    totalPages: null,
    error: null,
    loading: false,
    inhibitionSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_INHIBITIONS:
            return {
                ...state,
                loading: true
            }
        case LIST_INHIBITIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_INHIBITIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                inhibitions: action.payload.content,
                actualPage: action.payload.number,
                isLast: action.payload.last,
                isFirst: action.payload.first,
                total: action.payload.totalElements,
                totalPages: action.payload.totalPages
            }
        case SAVE_INHIBITIONS:
        case DELETE_INHIBITIONS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_INHIBITIONS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_INHIBITIONS_ERROR:
        case UPDATE_INHIBITIONS_ERROR:
        case DELETE_INHIBITIONS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_INHIBITIONS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                inhibitions: [...state.inhibitions, action.payload]
            }
        case ADD_INHIBITIONS:
            return {
                ...state,
                inhibitionSelected: null,
                isEdit: false
            }
        case EDIT_INHIBITIONS:
            return {
                ...state,
                inhibitionSelected: action.payload,
                isEdit: true
            }
        case UPDATE_INHIBITIONS_SUCCESS:
        case DELETE_INHIBITIONS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                inhibitions: state.inhibitions.map(inhibition => 
                    inhibition.id === action.payload.id ? inhibition = action.payload : inhibition
                ),
                inhibitionselected: null
            }
        // case DELETE_INHIBITIONS_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         inhibitions: state.inhibitions.filter( inhibition => inhibition.id !== action.payload)
        //     }
        default:
            return state;
    }
}